import { HttpResponse } from 'msw';

type LegacyBody = { command?: string; access?: string };

export function handleQosLegacy(
  body: LegacyBody,
): ReturnType<typeof HttpResponse.json> {
  const command = body.command ?? '';
  const access = body.access ?? 'get';

  switch (access) {
    case 'get':
      switch (command) {
        case 'get defaults':
          return HttpResponse.json(
            Array.from({ length: 24 }, (_, idx) => ({
              interface: idx + 1,
              'prio choice': 'default',
              queue: idx % 8,
              pcp: idx % 8,
            })),
            { status: 200 },
          );
        case 'get pcp->queue mapping':
          return HttpResponse.json([0, 1, 2, 3, 4, 5, 6, 7], { status: 200 });
        case 'get dscp->queue mapping':
          return HttpResponse.json(
            Array.from({ length: 64 }, (_, idx) => idx % 8),
            { status: 200 },
          );
        case 'get dscp->pcp mapping':
          return HttpResponse.json(
            Array.from({ length: 64 }, (_, idx) => idx % 8),
            { status: 200 },
          );
        default:
          return HttpResponse.json(
            {
              error: 'not implemented',
              msg: `Mock missing for qos:${command}`,
            },
            { status: 400 },
          );
      }
    case 'set':
      if (command.startsWith('set ')) {
        return HttpResponse.json({ ok: true }, { status: 200 });
      }
      return HttpResponse.json(
        { error: 'not implemented', msg: `Mock missing for qos:${command}` },
        { status: 400 },
      );
    default:
      return HttpResponse.json(
        {
          error: 'not implemented',
          msg: `Mock missing for qos access:${access}`,
        },
        { status: 400 },
      );
  }
}

export function handleMirroringLegacy(
  body: LegacyBody,
): ReturnType<typeof HttpResponse.json> {
  const command = body.command ?? '';
  const access = body.access ?? 'get';

  switch (access) {
    case 'get':
      if (command === 'get mirroring') {
        return HttpResponse.json(
          {
            src: Array.from({ length: 24 }, (_, idx) => ({
              interface: idx + 1,
              state: 'normal',
            })),
            dest: -1,
          },
          { status: 200 },
        );
      }
      break;
    case 'set':
      if (command === 'set mirroring') {
        return HttpResponse.json({ ok: true }, { status: 200 });
      }
      break;
    default:
      break;
  }

  return HttpResponse.json(
    { error: 'not implemented', msg: `Mock missing for mirroring:${command}` },
    { status: 400 },
  );
}
